import React  from "react";
import { useParams } from 'react-router-dom';
import AnnouncementForm from "./components/AnnouncementForm";

const EditAnnouncement = () => {
	const { announcementId } = useParams();

	console.log("announcementId", announcementId);

	return (
	    <div className="mt-3">
			<AnnouncementForm recordId={announcementId ?? 0} mode="edit"/>
	    </div>
    );
};

export default EditAnnouncement;